<script>
import moment from "moment";
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import Banners from "@/components/widgets/banners";
import HomeKpi from "@/components/widgets/home-kpi";
import HomeGoalProgress from "@/components/widgets/home-goal-progress";
import HomeSubscriptionsProgress from "@/components/widgets/home-subscriptions-progress";
import HomeQualification from "@/components/widgets/home-qualification";
import HomeCareerPlan from "@/components/widgets/home-career-plan";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Banners,
    HomeKpi,
    HomeGoalProgress,
    HomeSubscriptionsProgress,
    HomeQualification,
    HomeCareerPlan
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      monthYear: moment().format("MM/YYYY"),

      referral: {
        affiliate: process.env.VUE_APP_URL_PAINEL + this.$store.state.account.user.indication,
        client: process.env.VUE_APP_URL_CLIENTES + this.$store.state.account.user.indication,
      },

      loading: {
        kpis: true,
        qualification: true,
        goal: true,
        subscriptions: true,
        careerPlans: true,
      },

      dashboard: {
        kpis: {
          bonusTotal: {},
          newSubscriptions: {},
          qualification: {},
          performance: {},
        },
        goal: {},
        subscriptions: {},
        qualification: {
          months: [],
          qualified: false,
        },
        careerPlans: [1, 2, 3],
      },
    };
  },
  methods: {
    getKpis() {
      api
        .get("reports/kpis")
        .then(response => {
          if (response.data.status == "success") {
            this.dashboard.kpis = response.data.kpis;
          }
        })
        .finally(() => {
          this.loading.kpis = false;
        });
    },
    getQualification() {
      api
        .get("reports/qualification")
        .then(response => {
          if (response.data.status == "success") {
            this.dashboard.qualification = response.data.qualification;
          }
        })
        .finally(() => {
          this.loading.qualification = false;
        });
    },
    getGoal() {
      api
        .get("reports/goal")
        .then(response => {
          if (response.data.status == "success") {
            this.dashboard.goal = response.data.goal;
          }
        })
        .finally(() => {
          this.loading.goal = false;
        });
    },
    getSubscriptions() {
      api
        .get("reports/subscriptions")
        .then(response => {
          if (response.data.status == "success") {
            this.dashboard.subscriptions = response.data.subscriptions;
          }
        })
        .finally(() => {
          this.loading.subscriptions = false;
        });
    },
    getCareerPlan() {
      api
        .get("reports/carrerplan")
        .then(response => {
          if (response.data.status == "success") {
            this.dashboard.careerPlans = response.data.list;
          }
        })
        .finally(() => {
          this.loading.careerPlans = false;
        });
    },
  },
  mounted() {
    this.getKpis();
    this.getQualification();
    this.getGoal();
    this.getSubscriptions();
    this.getCareerPlan();
  },
};
</script>

<template>
  <Layout>
    <Banners></Banners>

    <div class="card mb-2">
      <div class="card-body py-2 d-flex align-items-center">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path
              d="M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z">
            </path>
            <path
              d="m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z">
            </path>
          </svg>
        </div>
        <template v-if="account.user.indication">
          <h5 class="mb-0 ml-2">Link de afiliado</h5>
          <div class="mt-1 ml-3">
            <ShareNetwork network="whatsapp" url="" :title="referral.affiliate">
              <i class="bx bxl-whatsapp font-size-24 text-dark p-0"></i>
            </ShareNetwork>
          </div>
          <div class="mt-1 ml-2">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.affiliate" v-on:click="$toast.success('O link foi copiado!')">
              <i class="bx bx-copy font-size-20 text-dark"></i>
            </button>
          </div>
        </template>
        <template v-else>
          <div class="py-2 ml-2">
            <h5 class="mb-0">Link de afiliado</h5>
            <router-link tag="a" to="/account/indication">
              Você ainda não possui um link de afiliado, <u>clique aqui</u> para criar.
            </router-link>
          </div>
        </template>
      </div>
    </div>

    <template v-if="account.user.indication">
      <div class="card">
        <div class="card-body py-2 d-flex align-items-center">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
              <path
                d="M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z">
              </path>
              <path
                d="m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z">
              </path>
            </svg>
          </div>
          <h5 class="mb-0 ml-2">Link de cliente</h5>
          <div class="mt-1 ml-3">
            <ShareNetwork network="whatsapp" url="" :title="referral.client">
              <i class="bx bxl-whatsapp font-size-24 text-dark p-0"></i>
            </ShareNetwork>
          </div>
          <div class="mt-1 ml-2">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.client" v-on:click="$toast.success('O link foi copiado!')">
              <i class="bx bx-copy font-size-20 text-dark"></i>
            </button>
          </div>
        </div>
      </div>
    </template>

    <div class="mb-3">
      <h4 class="mb-1">Visão Geral <sup>{{ monthYear }}</sup></h4>
      <p class="text-muted mb-0">Acompanhe seus bônus, sua meta mensal e seu plano de carreira.</p>
    </div>

    <div class="row">
      <div class="col-md-6 col-lg-3 mb-3">
        <HomeKpi :loading="loading.kpis" v-bind="dashboard.kpis.bonusTotal" />
      </div>
      <div class="col-md-6 col-lg-3 mb-3">
        <HomeKpi :loading="loading.kpis" v-bind="dashboard.kpis.newSubscriptions" />
      </div>
      <div class="col-md-6 col-lg-3 mb-3">
        <HomeKpi :loading="loading.kpis" v-bind="dashboard.kpis.qualification" />
      </div>
      <div class="col-md-6 col-lg-3 mb-3">
        <HomeKpi :loading="loading.kpis" v-bind="dashboard.kpis.performance" />
      </div>
    </div>

    <div class="mb-2">
      <h5 class="mb-1">Qualificação Mensal</h5>
      <p class="text-muted mb-0">É necessário bater 100+ novas assinaturas em pelo menos 1 dos últimos 3 meses para receber os bônus do Plano de Carreira serem liberados</p>
    </div>
    <div class="row">
      <div class="col-12 mb-3">
        <HomeQualification :loading="loading.qualification" v-bind="dashboard.qualification" />
      </div>
    </div>

    <div class="mb-2">
      <h5 class="mb-1">Afiliado Performance</h5>
      <p class="text-muted mb-0">{{ 'Novas assinaturas vendidas em ' + monthYear + ' — a contagem zera todo mês' }}</p>
    </div>
    <div class="row">
      <div class="col-12 mb-3">
        <HomeGoalProgress :loading="loading.goal" v-bind="dashboard.goal" />
      </div>
    </div>

    <div class="mb-2">
      <h5 class="mb-1">Assinaturas</h5>
      <p class="text-muted mb-0">{{ 'Meta de 100 assinaturas em ' + monthYear + ' para ganhar 3% sobre as assinaturas pagas no mês' }}</p>
    </div>
    <div class="row">
      <div class="col-12 mb-3">
        <HomeSubscriptionsProgress :loading="loading.subscriptions" v-bind="dashboard.subscriptions" />
      </div>
    </div>

    <div class="mb-2">
      <h5 class="mb-1">Plano de Carreira</h5>
      <p class="text-muted mb-0">Baseado no total de assinaturas próprias ativas — independente do mês</p>
    </div>
    <div class="row">
      <div v-for="(plan, index) of dashboard.careerPlans" :key="plan.key || index" class="col-md-4 mb-3">
        <HomeCareerPlan :loading="loading.careerPlans" v-bind="loading.careerPlans ? {} : plan" />
      </div>
    </div>
  </Layout>
</template>